export default "__VITE_ASSET__75Y$wL4zBnUdsT_GvmVMQg__"